import React, { useState } from "react";

const HelpPopup = ({ isOpen, onClose, slides }) => {
    const [current, setCurrent] = useState(0);

    if (!isOpen) return null;

    const change = (delta) => {
        if (!slides || slides.length === 0) return;
        let next = current + delta;
        if (next < 0) next = slides.length - 1;
        if (next >= slides.length) next = 0;
        setCurrent(next);
    };

    const active = slides[current] || {};

    return (
        <div className="popup fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-5 shadow-lg rounded-lg z-50 w-80 overflow-hidden">
            <button
                className="absolute top-2 right-2 bg-black text-white rounded-full w-8 h-8 flex items-center justify-center font-bold"
                onClick={onClose}
            >
                &times;
            </button>
            <div className="relative overflow-hidden mx-auto" style={{ width: "100%" }}>
                {active.src && (
                    <img
                        src={active.src}
                        alt={active.title || "Help"}
                        className="object-contain block mx-auto"
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                    />
                )}
                <button
                    className="prev absolute top-1/2 left-2 transform -translate-y-1/2 text-2xl"
                    onClick={() => change(-1)}
                >
                    &#10094;
                </button>
                <button
                    className="next absolute top-1/2 right-2 transform -translate-y-1/2 text-2xl"
                    onClick={() => change(1)}
                >
                    &#10095;
                </button>
            </div>
            <div className="mt-3">
                {active.title && <h3 className="text-base font-semibold">{active.title}</h3>}
                {active.description && (
                    <p className="text-sm text-gray-600 mt-1">{active.description}</p>
                )}
            </div>
        </div>
    );
};

export default HelpPopup;


